export const GOLDEN_TICKET_DISPLAY_NAME = "Golden Ticket";

const GOLDENTKT_HOST_FRAGMENT = "goldentkt";

const EMAIL_PATTERN = /[^\s@]+@[^\s@]+\.[^\s@]+/gi;

const TRAVELBRANDS_PATTERN = /\bTravel\s*Brands\b|\bTravelbrands\b|\bTRAVELBRANDS\b/gi;

const GIGI_PATTERN = /\bGiGi\b|\bGIGI\b|\bGigi\b/g;

const DOUBLE_BRAND_PATTERN = new RegExp(
  `(${GOLDEN_TICKET_DISPLAY_NAME.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s+)+`,
  "g"
);

export function isGoldenTicketHost() {
  if (typeof window !== "undefined" && typeof window.isGoldenticket === "function") {
    return window.isGoldenticket();
  }
  if (typeof window !== "undefined" && window.location?.hostname) {
    return window.location.hostname.toLowerCase().includes(GOLDENTKT_HOST_FRAGMENT);
  }
  return false;
}

function replaceBrandTokens(segment) {
  if (!segment) return segment;

  let result = segment
    .replace(TRAVELBRANDS_PATTERN, GOLDEN_TICKET_DISPLAY_NAME)
    .replace(GIGI_PATTERN, GOLDEN_TICKET_DISPLAY_NAME);

  result = result.replace(DOUBLE_BRAND_PATTERN, `${GOLDEN_TICKET_DISPLAY_NAME} `);

  return result;
}

export function applyGoldenTicketBranding(text) {
  if (!isGoldenTicketHost() || typeof text !== "string" || text.length === 0) {
    return text;
  }

  const placeholders = [];
  const withPlaceholders = text.replace(EMAIL_PATTERN, (email) => {
    const index = placeholders.length;
    placeholders.push(email);
    return `\u0000EMAIL${index}\u0000`;
  });

  let branded = replaceBrandTokens(withPlaceholders);

  placeholders.forEach((email, index) => {
    branded = branded.replace(`\u0000EMAIL${index}\u0000`, email);
  });

  return branded;
}
